@if (isBrowser) {
<div class="container py-5 d-flex justify-content-center">
    <div class="card shadow-sm border rounded-3 p-4" style="max-width: 700px; width: 100%;">
        <div class="text-center pb-3 border-bottom mb-4">
            <h3 class="fw-bold mb-1">Order Payment</h3>
            @if (cartData(); as data) {
            <p class="text-muted mb-0 small">Request ID: {{ data.requestNumber }}</p>
            }
        </div>

        @if (cartData(); as data) {
        <!-- Order Summary Section -->
        <div class="mb-4">
            <h6 class="fw-bold text-secondary mb-3">Order Summary</h6>
            <div class="list-group list-group-flush mb-3">
                @for (item of data.cartItems; track $index) {
                @if(item.total_fee > 0 && item.total_fee !== "0.00"){
                <div
                    class="list-group-item d-flex justify-content-between align-items-center px-0 bg-transparent py-2 border-0">
                    <div>
                        <span class="fw-medium">{{ item.document_name }}</span>
                        <span class="text-muted small ms-1">(x{{ item.count }})</span>
                    </div>
                    <span class="text-dark fw-semibold">${{ item.total_fee }}</span>
                </div>
                }
                }
                @if (data.fedex_total_fees > 0) {
                @for (item of data.fedex_files; track $index) {
                <div class="list-group-item d-flex justify-content-between align-items-center px-0 bg-transparent py-2">
                    <div>
                        <span class="fw-medium">
                            {{ item.direction == "inbound" ? 'Inbound' : item.direction == "outbound" ? 'Outbound' :
                            "International"}}
                        </span>
                    </div>
                    <span class="text-dark fw-semibold">${{ item.final_amount }}</span>
                </div>
                }
                }
                <div class="list-group-item d-flex justify-content-between align-items-center px-0 bg-transparent py-2">
                    <div>
                        <span class="fw-medium">Handling Fee</span>
                    </div>
                    <span class="text-dark fw-semibold">${{ data.handling_fees }}</span>
                </div>
            </div>

            <div class="bg-light rounded p-3 mb-3">
                <div class="d-flex justify-content-between mb-2 small text-muted">
                    <span>Expected Date</span>
                    <span>{{ data.expected_date }}</span>
                </div>
                <div class="d-flex justify-content-between mb-2 small text-muted">
                    <span>Processing Time</span>
                    <span>{{ data.total_time }} days</span>
                </div>
                <div class="d-flex justify-content-between mb-0 small text-muted">
                    <span>Shipping Method</span>
                    <span>{{ data.shipping_method }}</span>
                </div>
            </div>

            <div class="d-flex justify-content-between align-items-center pt-2 border-top">
                <span class="fs-5 fw-bold">Total to Pay</span>
                <span class="fs-4 fw-bold text-primary">${{ data.total_fee }}</span>
            </div>
        </div>
        } @else {
        <div class="text-center py-5">
            <div class="spinner-border text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
            <p class="mt-3 text-muted">Loading order...</p>
        </div>
        }

        <!-- Action / Button Form (Always rendered so AcceptUI can bind to it) -->
        <div class="mt-4" [hidden]="!cartData()">
            @if (!paymentSuccess) {
            <form id="paymentForm" method="POST" action="">
                <input type="hidden" name="dataValue" id="dataValue" [value]="tokenValue" />
                <input type="hidden" name="dataDescriptor" id="dataDescriptor" [value]="descriptorValue" />

                <button type="button" class="AcceptUI btn btn-primary btn-lg w-100 py-3 fw-bold"
                    [disabled]="!cartData() || orderProcessing.isUploading()"
                    data-billingAddressOptions='{"show":false, "required":false}'
                    [attr.data-apiLoginID]="apiLoginID"
                    [attr.data-clientKey]="clientKey"
                    data-acceptUIFormBtnTxt="Submit" data-acceptUIFormHeaderTxt="Card Information"
                    data-paymentOptions='{"showCreditCard": true, "showBankAccount": false}'
                    data-responseHandler="responseHandler">
                    Pay Now
                </button>
            </form>
            } @else {
            <div class="alert alert-success d-flex align-items-center border-0 rounded p-3 mb-0" role="alert">
                <i class="bi bi-check-circle-fill me-2 fs-5 text-success"></i>
                <div>
                    <h6 class="alert-heading fw-bold mb-1">Payment Successful</h6>
                    <p class="mb-0 small text-break">Token: {{ tokenValue }}</p>
                </div>
            </div>
            }

            @if (errorMessages.length > 0) {
            <div class="alert alert-danger mt-3 border-0 rounded p-3" role="alert">
                <h6 class="fw-bold mb-2">Errors:</h6>
                <ul class="mb-0 ps-3 small">
                    @for (msg of errorMessages; track msg) {
                    <li>{{ msg }}</li>
                    }
                </ul>
            </div>
            }
        </div>

        <div class="text-center mt-4">
            <small class="text-muted">
                <i class="bi bi-shield-lock-fill text-success me-1"></i>
                Secure payment processed via Authorize.Net
            </small>
        </div>
    </div>
</div>
}